import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import StarRatings from 'react-star-ratings';
import noPhoto from '../../../assets/img/noPhoto.svg';
import { useNavigate } from 'react-router-dom';

// Components
import Icon from 'src/ui/Icon';

// Services
import DetailInfo from 'src/components/cards/shared/DetailInfo';
import { getTherapistDetailUseCase } from 'src/services/therapy/useCases';
import Button from 'src/ui/Button';

const TherapistProfile = () => {
  const params = useParams<{ therapistId: string }>();
  const TherapistDetail = useAppSelector((state) => state.therapy.TherapistDetail);
  const role = useAppSelector((state) => state.auth.role);
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['therapy']);
  const navigate = useNavigate();

  useEffect(() => {
    if (role === 'admin' && params.therapistId) {
      dispatch(getTherapistDetailUseCase(params.therapistId));
    } else if (role === 'therapist') {
      // dispatch(getTherapistDetailUseCase(localStorage.getItem('him-auth-token') || ''));
    }
  }, [dispatch, params.therapistId, role]);

  return (
    <div className='overflow-auto w-full '>
      <div className='flex w-full'>
        <div className='therapyInfo'>
          <div className='flex '>
            <div className='w-4/5 flex justify-center '>
              <div className='coach-picture'>
                <div
                  className={`coach-preview w-48 h-48 ${
                    TherapistDetail.profilePicture ? 'bg-cover' : ''
                  }`}
                  style={{
                    backgroundImage: `url(${TherapistDetail.profilePicture || noPhoto})`,
                  }}
                />
              </div>
              <div className='coach-contact-info w-full'>
                <div className='flex mb-2'>
                  <span className='text-xl self-center '>{TherapistDetail.fullName}</span>{' '}
                </div>
                <div className='mb-2'>
                  <StarRatings
                    rating={TherapistDetail.rating}
                    starRatedColor='#9362C7'
                    numberOfStars={5}
                    name='rating'
                    starDimension='20px'
                    starSpacing='2px'
                  />
                </div>
                <DetailInfo info={TherapistDetail.email}>
                  <Icon icon='email' />
                </DetailInfo>
                <DetailInfo info={TherapistDetail.phone}>
                  <Icon icon='phone' />
                </DetailInfo>
                <DetailInfo
                  info={
                    TherapistDetail.address
                      ? TherapistDetail.address
                      : t('TherapyProfile.noLocation')
                  }
                >
                  <Icon icon='location' />
                </DetailInfo>
              </div>
              {role === 'therapist' && (
                <Button
                  style={{ height: 'fit-content' }}
                  extraClass='h-1/4 bg-secondary text-white active:bg-blueGray-600 text-sm font-medium p-2 rounded-xl shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150'
                  onClick={() => navigate(`/therapist/${TherapistDetail.id}/edit-therapy`)}
                >
                  {t('TherapyProfile.edit')}
                </Button>
              )}
            </div>
          </div>
          <div className='flex flex-col'>
            <div className='therapistDescripionsInfo pt-4 w-full'>
              <div className='1y font-bold text-base text-[#AE8AD5]'>{t('psum')}</div>
              {TherapistDetail.description && (
                <span className='therapist-description'>{TherapistDetail.description}</span>
              )}
            </div>
            <div className='1y font-bold text-base text-[#AE8AD5]'>{t('sdesc')}</div>
            <div className='therapistDescripionsInfo w-full'>
              {TherapistDetail?.shortDescription && (
                <span className='therapist-description'>{TherapistDetail.shortDescription}</span>
              )}
            </div>
            <div className='1y font-bold text-base text-[#AE8AD5]'>{t('gender')}</div>
            <div className='therapistDescripionsInfo w-full'>
              {TherapistDetail?.gender && (
                <span className='therapist-description'>{TherapistDetail.gender}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TherapistProfile;
